'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ajax = require('../xhr');
var Url = require('../util/url');
var Extend = require('../util/extend');
var Logan = require('../util/logan');
var Logger = require('../util/logger');
var CanIUse = require('../util/caniuse');

var _require = require('../constant/patterns'),
    jsPattern = _require.jsPattern,
    cssPattern = _require.cssPattern,
    imgPattern = _require.imgPattern,
    urlPattern = _require.urlPattern;

var FirstScreenManager = require('./firstScreen');
var parseInt = Number.parseInt || window.parseInt;
var NAME = 'page';

var parseTime = function parseTime(time) {
    var temp = Math && Math.round ? Math.round(time) : time;
    return parseInt(temp);
};

var PageManager = function () {
    function PageManager(cfgManager, errManager) {
        _classCallCheck(this, PageManager);

        this.cfgManager = cfgManager;
        this.errManager = errManager;
        this.points = [];
        this.pointsCustom = [];
        this.noCache = 'false';
        this.titansTags = {};
    }
    //因为FST指标是load后计算，期间用户可能跳转页面或对config进行设置，所以预先存储pageUrl和project


    _createClass(PageManager, [{
        key: 'setInitConfig',
        value: function setInitConfig() {
            this.initialPage = this.cfgManager.get('pageUrl');
            this.initialProject = this.cfgManager.get('project');
        }
        // custom points ready

    }, {
        key: 'setUserReady',
        value: function setUserReady() {
            if (this.cfgManager.get(NAME).auto) return;
            this.cfgManager.set({ page: { auto: true } });
        }
    }, {
        key: 'getUserReady',
        value: function getUserReady() {
            return this.cfgManager.get(NAME).auto;
        }
        // default points ready

    }, {
        key: 'setReady',
        value: function setReady() {
            this.isReady = true;
        }
    }, {
        key: 'getReady',
        value: function getReady() {
            return this.isReady;
        }
    }, {
        key: 'getPerformaceTiming',
        value: function getPerformaceTiming() {
            return {
                perf: window.performance && window.performance.timing,
                paint: window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('paint')
            };
        }
        // get resource timing of critical resources

    }, {
        key: 'getMainResourceTiming',
        value: function getMainResourceTiming() {
            var resourceTiming = window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('resource');
            var filter = this.cfgManager.get(NAME).isMainResource;
            var mainResourceTiming = [];
            try {
                if (!resourceTiming) return;

                if (typeof filter === 'function') {
                    for (var i = 0; i < resourceTiming.length; i++) {
                        var item = resourceTiming[i];
                        if (filter(item)) {
                            mainResourceTiming.push(item);
                        }
                    }
                    return mainResourceTiming;
                } else {
                    for (var _i = 0; _i < resourceTiming.length; _i++) {
                        var resource = resourceTiming[_i];
                        if (resource.initiatorType === 'link' || resource.initiatorType === 'script') {
                            mainResourceTiming.push(resource);
                        }
                    }
                    var size = this.cfgManager.get(NAME).mainResourceNumber;
                    if (mainResourceTiming.length <= size) {
                        return mainResourceTiming;
                    } else {
                        return mainResourceTiming.splice(0, size);
                    }
                }
            } catch (e) {
                Logger.ignore(e);
            }
        }
        // 启动首屏时间 FST 的计算

    }, {
        key: 'sensoryObserver',
        value: function sensoryObserver() {
            this.firstScreenManager = new FirstScreenManager(this.cfgManager, this);
            this.firstScreenManager.mutaObserver();
        }
    }, {
        key: 'getRouteFst',
        value: function getRouteFst(path, prevPath) {
            if (this.firstScreenManager && path) {
                if (prevPath) {
                    this.firstScreenManager.stopRouteMutaObserver(prevPath);
                }
                if (Math.random() < this.cfgManager.get(NAME).sample) {
                    this.firstScreenManager.startRouteMutaObserver(path);
                }
            }
        }
    }, {
        key: 'reportRouteFst',
        value: function reportRouteFst(result, pageUrl) {
            var _this = this;

            var cfgManager = this.cfgManager;
            setTimeout(function () {
                var points = [];
                points[27] = result;
                var data = Extend({
                    project: cfgManager.get('project'),
                    pageurl: encodeURIComponent(pageUrl),
                    speed: encodeURIComponent(points.join('|')),
                    customspeed: '',
                    timestamp: +new Date(),
                    noCache: _this.noCache,
                    pageId: cfgManager.get('pageId')
                }, cfgManager.getExtension());
                var url = Url.stringify(cfgManager.getApiPath(NAME), data);
                Ajax({
                    url: url,
                    method: 'GET'
                });
            }, 0);
        }
    }, {
        key: 'parsePageTimeWithDefer',
        value: function parsePageTimeWithDefer() {
            var _this2 = this;

            setTimeout(function () {
                try {
                    if (_this2.cfgManager.get(NAME).sensoryIndex) {
                        _this2.firstScreenManager.getSensoryIndex(function (senseTime) {
                            _this2.parsePageTime(senseTime); // W3C points and paint time (FST, FP, FCP)
                            _this2.parseFirstScreenPerf(senseTime); // first screen performance analysis
                        });
                    } else {
                        _this2.parsePageTime();
                    }
                } catch (e) {
                    _this2.parsePageTime();
                }
            }, 0);
        }
    }, {
        key: 'parsePageTime',
        value: function parsePageTime(senseTime) {
            var _getPerformaceTiming = this.getPerformaceTiming(),
                perf = _getPerformaceTiming.perf,
                paint = _getPerformaceTiming.paint;

            if (!perf) return this.setReady();

            var navStart = perf.navigationStart;
            var perfMap = {
                unloadEventStart: 1,
                unloadEventEnd: 2,
                redirectStart: 3,
                redirectEnd: 4,
                fetchStart: 5,
                domainLookupStart: 6,
                domainLookupEnd: 7,
                connectStart: 8,
                // secureConnectionStart
                connectEnd: 9,
                requestStart: 10,
                responseStart: 11,
                responseEnd: 12,
                domLoading: 13,
                domInteractive: 14,
                domContentLoadedEventStart: 15,
                domContentLoadedEventEnd: 16,
                domComplete: 17,
                loadEventStart: 18,
                loadEventEnd: 19
            };
            for (var key in perfMap) {
                var value = perf[key] || 0;
                this.points[perfMap[key]] = value ? value - navStart : 0;
            }
            this.points[20] = perf.domainLookupEnd - perf.domainLookupStart; // dns
            this.points[21] = perf.connectEnd - perf.connectStart; // tcp
            this.points[22] = perf.responseEnd - perf.requestStart; // download

            var firstPaint = 0;
            var firstContentfulPaint = 0;
            if (paint && paint.length) {
                for (var i = 0; i < paint.length; i++) {
                    var item = paint[i];
                    if (item.name === 'first-paint') {
                        firstPaint = parseInt(item.startTime);
                    } else if (item.name === 'first-contentful-paint') {
                        firstContentfulPaint = parseInt(item.startTime);
                    }
                }
                if (firstPaint && firstContentfulPaint) {
                    this.points[23] = firstPaint;
                    this.points[24] = firstContentfulPaint;
                }
            }
            if (senseTime) {
                this.points[25] = senseTime.FST && senseTime.FST > firstContentfulPaint ? senseTime.FST : firstContentfulPaint;
                this.points[26] = senseTime.FCP || firstContentfulPaint || this.points[15];
            }
            if (window.Owl && window.Owl.fstInfo) {
                window.Owl.fstInfo.FST = this.points[25];
            }

            try {
                // handle titans perf timing
                var titansData = window.titansReport;
                if (!titansData && window.KNBTitansXSync && typeof window.KNBTitansXSync.getTitansReport === 'function') {
                    var result = window.KNBTitansXSync.getTitansReport();
                    titansData = result && JSON.parse(result);
                }
                if (titansData) {
                    if (titansData.h5Env) {
                        var envInfo = titansData.h5Env;
                        if (envInfo.timestamp && envInfo.timestamp.h5EnvInit) {
                            this.points[28] = perf.loadEventStart - envInfo.timestamp.h5EnvInit;
                        }
                        if (envInfo.timing) {
                            this.points[29] = envInfo.timing.h5EnvPrepare;
                            this.points[30] = envInfo.timing.pagePreprocess;
                            this.points[31] = envInfo.timing.webviewPrepare;
                        }
                        if (envInfo.tag && typeof envInfo.tag.isWebViewInitialed != 'undefined') {
                            this.titansTags.isWebViewInitialed = envInfo.tag.isWebViewInitialed ? 'true' : 'false';
                        }
                    }
                    if (titansData.urlPreprocess) {
                        var urlPreInfo = titansData.urlPreprocess;
                        if (urlPreInfo.timing) {
                            this.points[32] = urlPreInfo.timing.urlPreprocess;
                        }
                        if (urlPreInfo.tag && typeof urlPreInfo.tag.isInterJump != 'undefined') {
                            this.titansTags.isInterJump = urlPreInfo.tag.isInterJump ? 'true' : 'false';
                        }
                    }
                    if (titansData.commonTag && titansData.commonTag.titansCoreVersion) {
                        this.titansTags.titansCoreVersion = titansData.commonTag.titansCoreVersion;
                    }
                }
            } catch (e) {
                this.errManager.reportSystemWarn(e);
            }

            for (var _i2 = 0; _i2 < this.points.length; _i2++) {
                if (isNaN(this.points[_i2]) || this.points[_i2] < 0) {
                    this.points[_i2] = 0;
                }
            }
            var cfgManager = this.cfgManager;
            var logInfo = {
                project: cfgManager.get('project'),
                pageUrl: cfgManager.get('pageUrl'),
                start: this.points[11],
                dcl: this.points[16],
                load: this.points[18],
                fst: this.points[25] || 0
            };
            Logan._log('[Performance]:' + JSON.stringify(logInfo), 'owl', 'info', ['perf']);

            // is cache hit
            var resTiming = this.getMainResourceTiming();
            if (resTiming) {
                var timeThreshold = cfgManager.get(NAME).timeThreshold;
                for (var _i3 = 0; _i3 < resTiming.length; _i3++) {
                    var res = resTiming[_i3];
                    if (res.transferSize !== undefined) {
                        if (res.transferSize !== 0) this.noCache = 'true';
                    } else if (res.duration !== undefined) {
                        if (res.duration > timeThreshold) this.noCache = 'true';
                    }
                }
            }

            this.setReady();
            this.report();
        }
        // handle custom points

    }, {
        key: 'push',
        value: function push(point) {
            if (!point || typeof point.position != 'number' || point.position < 0 || point.position > 31) return;
            this.pointsCustom[point.position] = point.duration || 0;
            this.report();
        }
    }, {
        key: 'clearTimeout',
        value: function (_clearTimeout) {
            function clearTimeout() {
                return _clearTimeout.apply(this, arguments);
            }

            clearTimeout.toString = function () {
                return _clearTimeout.toString();
            };

            return clearTimeout;
        }(function () {
            clearTimeout(this.timeout);
            this.timeout = undefined;
        })
    }, {
        key: 'report',
        value: function report(reportNow) {
            var _this3 = this;

            var cfgManager = this.cfgManager;
            var catchPage = cfgManager.get('autoCatch').page;
            if (catchPage && !this.getReady()) return;
            if (!this.getUserReady()) return;
            if (!this.points.length && !this.pointsCustom.length) return;
            if (Math.random() > cfgManager.get(NAME).sample) return;

            try {
                if (this.timeout) {
                    this.clearTimeout();
                } else if (this.pendingAjax && typeof this.pendingAjax.abort === 'function') {
                    this.pendingAjax.abort();
                }
            } catch (e) {
                this.errManager.reportSystemError(e);
            }

            var doSend = function doSend() {
                _this3.clearTimeout();
                if (!_this3.points.length && !_this3.pointsCustom.length) return;

                // 默认性能指标上报至最先设置的pageUrl内容
                var pageUrl = _this3.points.length && _this3.initialPage || cfgManager.get('pageUrl');
                var project = _this3.points.length && _this3.initialProject || cfgManager.get('project');
                var ext = cfgManager.getExtension();
                var data = Extend({
                    project: project,
                    pageurl: encodeURIComponent(pageUrl),
                    speed: encodeURIComponent(_this3.points.join('|')),
                    customspeed: encodeURIComponent(_this3.pointsCustom.join('|')),
                    timestamp: +new Date(),
                    noCache: _this3.noCache,
                    pageId: cfgManager.get('pageId')
                }, ext);
                data = Extend(data, _this3.titansTags);
                var url = Url.stringify(cfgManager.getApiPath(NAME), data);
                _this3.pendingAjax = Ajax({
                    method: 'GET',
                    url: url,
                    success: function success() {
                        _this3.points = [];
                        _this3.pointsCustom = [];
                        _this3.pendingAjax = undefined;
                    },
                    xhrRewritten: cfgManager.get('autoCatch').ajax ? true : false
                });
            };

            var delay = cfgManager.get(NAME).delay || 0;
            if (reportNow) {
                doSend();
            } else if (delay >= 0) {
                this.timeout = setTimeout(function () {
                    doSend();
                }, delay);
            }
        }
        // 解析并上报页面首屏的性能指标及慢访问个案数据

    }, {
        key: 'parseFirstScreenPerf',
        value: function parseFirstScreenPerf(senseTime) {
            var _this4 = this;

            var cfgManager = this.cfgManager;
            var pageConfig = cfgManager.get(NAME);
            // 确保测速点上报之后再开始解析首屏性能指标
            var delay = pageConfig.delay || 0;
            setTimeout(function () {
                if (pageConfig.fstPerfAnalysis === true && senseTime && senseTime.FST) {
                    var resEntries = window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('resource');
                    if (resEntries && resEntries.length) {
                        var fst = parseInt(senseTime.FST || 0);
                        var random = Math.random();
                        var logSumInfo = random < pageConfig.fstPerfSample;
                        // 首屏时间超过 1s 且命中采样率时上报慢访问的个案数据, 暂不支持不同区间内采样率的可配置
                        var sampleRate = fst < 2000 ? 0.05 : 0.1;
                        var logSlowView = pageConfig.logSlowView === true && fst > 1000 && random < sampleRate;
                        if (logSumInfo) {
                            // 首屏性能指标汇总数据
                            var sumInfo = {
                                picCount: 0,
                                picSize: 0,
                                jsCount: 0,
                                jsSize: 0,
                                cssCount: 0,
                                cssSize: 0,
                                ajaxCount: 0
                                // 慢访问个案数据
                            };var resList = {
                                js: {},
                                css: {},
                                img: {},
                                ajax: {}
                                // initiatorType 不能代表请求资源的类型, 需要进一步通过以下正则做匹配
                            };var time = void 0,
                                start = void 0,
                                stalled = void 0,
                                dns = void 0,
                                tcp = void 0,
                                ssl = void 0,
                                ttfb = void 0,
                                load = void 0,
                                hit = void 0,
                                logStr = void 0;
                            try {
                                resEntries.filter(function (res) {
                                    // 筛选 fetchStart 在 fst 之前的资源请求
                                    return res.fetchStart && res.fetchStart < fst;
                                }).forEach(function (res) {
                                    var type = '';
                                    var name = res.name || '';
                                    var initType = res.initiatorType || '';
                                    var size = res.transferSize || 0;
                                    if (name && initType) {
                                        if (initType === 'img' || name.match(imgPattern)) {
                                            type = 'img';
                                            sumInfo.picCount++;
                                            sumInfo.picSize += size;
                                        } else if (initType === 'script' || initType === 'link' && name.match(jsPattern)) {
                                            type = 'js';
                                            sumInfo.jsCount++;
                                            sumInfo.jsSize += size;
                                        } else if (initType === 'css' || initType === 'link' && name.match(cssPattern)) {
                                            type = 'css';
                                            sumInfo.cssCount++;
                                            sumInfo.cssSize += size;
                                        } else if (initType === 'xmlhttprequest' || initType === 'fetch' || initType === 'beacon') {
                                            type = 'ajax';
                                            sumInfo.ajaxCount++;
                                        }
                                    }

                                    if (logSlowView && type && name) {
                                        var matches = name.match(urlPattern);
                                        if (matches && matches[1] && matches[2]) {
                                            var bodySize = res.decodedBodySize || 0;
                                            var duration = res.duration || 0;
                                            time = parseTime(res.responseEnd - res.fetchStart);
                                            start = parseTime(res.fetchStart);
                                            stalled = parseTime(res.domainLookupStart - res.fetchStart);
                                            dns = parseTime(res.domainLookupEnd - res.domainLookupStart);
                                            tcp = parseTime(res.connectEnd - res.connectStart);
                                            ssl = parseTime(res.connectEnd - res.secureConnectionStart);
                                            ttfb = parseTime(res.responseStart - res.requestStart);
                                            load = parseTime(res.responseEnd - res.responseStart);
                                            hit = (size > 0 ? false : bodySize > 0 ? true : duration < 30) ? 1 : 0;
                                            logStr = '' + size + ',' + time + ',' + start + ',' + dns + ',' + tcp + ',' + ssl + ',' + ttfb + ',' + load + ',' + stalled + ',' + hit;
                                            if (resList[type][matches[1]] instanceof Array) {
                                                resList[type][matches[1]].push([matches[2], logStr]);
                                            } else {
                                                resList[type][matches[1]] = [[matches[2], logStr]];
                                            }
                                        }
                                    }
                                });

                                // 上报首屏性能的汇总数据
                                var url = Url.stringify(cfgManager.getApiPath('fstInfo'));
                                var data = Extend({
                                    p: _this4.initialProject || cfgManager.get('project'),
                                    page: _this4.initialPage || cfgManager.get('pageUrl'),
                                    ts: Date.now(),
                                    pageId: cfgManager.get('pageId'),
                                    unionId: cfgManager.getExtension('unionId'),
                                    respTime: fst
                                }, sumInfo);
                                Ajax({
                                    type: 'POST',
                                    url: url,
                                    header: {
                                        'Content-Type': 'application/x-www-form-urlencoded'
                                    },
                                    data: 'data=' + encodeURIComponent(JSON.stringify(data))
                                });
                                // 上报慢访问个案数据
                                if (logSlowView) {
                                    var _url = Url.stringify(cfgManager.getApiPath('fstLog'));
                                    var _data = {
                                        p: _this4.initialProject || cfgManager.get('project'),
                                        page: _this4.initialPage || cfgManager.get('pageUrl'),
                                        ts: Date.now(),
                                        pageId: cfgManager.get('pageId'),
                                        unionId: cfgManager.getExtension('unionId'),
                                        respTime: fst,
                                        content: JSON.stringify(resList)
                                    };
                                    Ajax({
                                        type: 'POST',
                                        url: _url,
                                        header: {
                                            'Content-Type': 'application/x-www-form-urlencoded'
                                        },
                                        data: 'data=' + encodeURIComponent(JSON.stringify(_data))
                                    });
                                }
                                // 首屏最后一次DOM变更的时间及其Xpath路径
                            } catch (e) {
                                _this4.errManager.reportSystemError(e);
                            }
                        }
                    }
                }
            }, delay);
        }
    }, {
        key: 'manualReportFST',
        value: function manualReportFST() {
            var _this5 = this;

            var pageConfig = this.cfgManager.get(NAME);
            if (pageConfig.sensoryIndex || !pageConfig.manualReportFST || this.firstScreenManager) return;
            if (!CanIUse.PerformanceNow()) return;

            // 清空数据
            this.points = [];
            this.pointsCustom = [];
            if (window._Owl_ && window._Owl_.pageData) {
                window._Owl_.pageData = [];
            }
            // 设置计时起点
            var time = parseInt(performance.now());
            // 开启 FST 的监听计算
            this.sensoryObserver();
            // 等待 FST 计算完成并上报
            setTimeout(function () {
                try {
                    if (pageConfig && pageConfig.manualReportFST) {
                        _this5.firstScreenManager.getSensoryIndex(function (senseTime) {
                            _this5.parseAsyncFST(senseTime, time);
                        });
                    }
                } catch (e) {
                    Logger.ignore(e);
                }
            }, 0);
        }
    }, {
        key: 'parseAsyncFST',
        value: function parseAsyncFST(senseTime, startTime) {
            if (senseTime) {
                var fst = parseInt(senseTime.FST || 0) - startTime;
                var fcp = parseInt(senseTime.FCP || 0) - startTime;
                if (fst > 0) {
                    this.points[25] = fst;
                    this.points[26] = fcp > 0 ? fcp : 0;
                }
            }

            // 其他默认测速点置为 0
            for (var i = 0; i < this.points.length; i++) {
                if (isNaN(this.points[i])) {
                    this.points[i] = 0;
                }
            }

            this.setReady();
            this.report();
        }
    }]);

    return PageManager;
}();

module.exports = PageManager;